import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import GenericCheckboxInputField from '../form-fields/GenericCheckboxInputField';
import { getPrivacyPolicyPageUrlByCountry } from '../UrlUtils';

const GenericFormPrivacyPolicySection = (props) => {
    const privacyPolicyUrl = getPrivacyPolicyPageUrlByCountry(props.country);
    const policyAcceptanceContent = (
        <span>
            I acknowledge receipt of the{' '}
            <Link
                to={privacyPolicyUrl}
                target="_blank"
                className={'text-blue-700 font-bold'}
                rel="noreferrer"
                data-testid={`privacy-notice-link-${props.country}`}
            >
                Privacy Notice
            </Link>{' '}
            and confirm that I have read, understood and accept the information
            set forth therein.{' '}
        </span>
    );

    return (
        <div>
            <GenericCheckboxInputField
                name="privacyPolicy.privacyPolicyAccepted"
                label={policyAcceptanceContent}
                errorMsg={
                    'Please confirm that you have read the privacy notice'
                }
                required
                fieldClassName={props.fieldClassName}
            />
        </div>
    );
};

GenericFormPrivacyPolicySection.propTypes = {
    country: PropTypes.string,
    fieldClassName: PropTypes.func,
};

export default GenericFormPrivacyPolicySection;
